<template>
  <section id="about" class="n3-notario" :class="{ 'n3-notario--invertido': PN.ImageLeft === false }" v-if="PN?.Mostrar">
    <figure v-if="PN.Imagen" class="n3-notario__foto">
      <img :src="imagenIDtoSRC(PN.Imagen)" :alt="'Fotografía de ' + NOTARIA.Nombre + ' - Notario'" loading="lazy" />
    </figure>
    <div class="n3-notario__texto n2-aparece">
      <span class="n3-comillas" aria-hidden="true">“</span>
      <h2 class="n2-titulo-seccion" v-html="PN.Titulo?.Texto"></h2>
      <div v-if="PN.Descripcion?.Texto" class="n2-texto-rico" :style="alineacionTexto(PN.Descripcion.css)" v-html="PN.Descripcion.Texto"></div>
      <NuxtLink v-if="NOTARIA.Theme.Menu?.ShowNotarios && NOTARIA.Notarios?.length" :to="getLocalePath('/notarios')" class="n2-enlace">
        {{ tituloSeccion(NOTARIA, 'Notario', $t) }} <span aria-hidden="true">→</span>
      </NuxtLink>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { tituloSeccion, alineacionTexto } from '../../composables/useNotaria2'
const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()
// Panel: Inicio → Palabras del notario
const PN = computed(() => NOTARIA.value?.Theme?.Home?.PN)
</script>
